import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { OrderDetailsPageContext } from "@insite/content-library/Pages/OrderDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsAccountStyles {
    wrapper?: InjectableCss;
    titleText?: TypographyProps;
    account?: TypographyProps;
}

export const accountStyles: OrderDetailsAccountStyles = {
    wrapper: {
        css: css`
            padding-bottom: 10px;
        `,
    },
    titleText: {
        variant: "h3",
        as: "h3",
        css: css`
            @media print {
                font-size: 12px;
            }
            margin-bottom: 5px;
        `,
    },
    account: {
        css: css`
            font-size: 14px !important;
        `,
    },
};

const styles = accountStyles;

const OrderDetailsCollectAccountNo: FC = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.properties.collectAccountNumber) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} id="orderDetailsStatus">
                {translate("Account#")}
            </Typography>
            <Typography {...styles.account}>{order.properties.collectAccountNumber}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsCollectAccountNo,
    definition: {
        allowedContexts: [OrderDetailsPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
